import { EventPayload } from '../useEventTracker';

export const getCoBrokeEnquiryClickedPayload = (
    payload: EventPayload & Record<string, any>,
    originId?: string,
): any => {
    return {
        feature: 'Co Broke',
        feature_detail: 'Ajukan Co-broke button',
        feature_object_id: originId,
        feature_object_type: 'Listing',
        feature_listing_class: 'Secondary',
        feature_listing_agent_id: payload?.agent_id,
    };
};
